var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sale-settings-radio-button",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"outer-circle",class:{ 'active': _vm.value }},[_c('div',{staticClass:"inner-circle",class:_vm.color})])])}
var staticRenderFns = []

export { render, staticRenderFns }